import * as React from 'react'

import { type SortDirection, Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface HeaderProps {
  onSort: (attribute: string, direction: SortDirection) => void
  attribute: string
  direction: SortDirection
}

const Header = ({ onSort, attribute, direction }: HeaderProps) => {
  const titles = [
    {
      name: i18n.t('surveys.index.table.header.name'),
      colSpan: 2,
      attribute: 'name',
    },
    {
      name: i18n.t('surveys.index.table.header.participation'),
      colSpan: 2,
      attribute: 'question_groups_count',
    },
    {
      name: i18n.t('surveys.index.table.header.state'),
      colSpan: 2,
      attribute: 'status',
    },
    {
      name: i18n.t('surveys.index.table.header.state_date'),
      colSpan: 2,
      attribute: 'start_on',
    },
    {
      name: i18n.t('surveys.index.table.header.end_date'),
      colSpan: 2,
      attribute: 'end_on',
    },
  ]

  return (
    <Table.Head>
      <Table.Row>
        {titles.map((title) => (
          <Table.SortableHeadCell
            colSpan={title.colSpan}
            key={title.name}
            attribute={title.attribute}
            onSort={onSort}
            sortAttribute={attribute}
            sortDirection={direction}
          >
            {title.name}
          </Table.SortableHeadCell>
        ))}
        <Table.HeadCell colSpan={1} />
      </Table.Row>
    </Table.Head>
  )
}

export default Header
